import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CreateGamePayment from './CreateGamePayment';


// Replace with your actual Stripe publishable key
const stripePromise = loadStripe("pk_test_1234567890abcdefghijklmnop");

const CreateGamePaymentWrapper = () => {
  return (
    <Elements stripe={stripePromise}>
      <CreateGamePayment/>
    </Elements>
  );
};

export default CreateGamePaymentWrapper;
